export default [
    {
        path: 'relatorio-tempo-atendimento',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-tempo-atendimento' */
            '@/views/ambulatorio/relatorio-tempo-atendimento/Index'
        ),
        redirect: 'relatorio-tempo-atendimento/index',
        children: [
            {
                name: 'ambulatorio-relatorio-tempo-atendimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-tempo-atendimento' */
                    '@/views/ambulatorio/relatorio-tempo-atendimento/List.vue'
                ),
            },
        ],
    },
]
